import {registerPlugin} from '@capacitor/core';
import {NumberSeparators} from '../domain/number-separators';

export interface NumberFormatPlugin {
  getNumberFormat(): Promise<NumberSeparators>;
}

const NumberFormat = registerPlugin<NumberFormatPlugin>('NumberFormat');

export default NumberFormat;
